module.exports = __webpack_public_path__ + "static/img/sec3-content-img@t.35af0f9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/transys/sec3-content-img@t.png
// module id = XN7n
// module chunks = 0